import Card from 'components/Card'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

const Interfaces = (props) => {
  const {} = props
  const { t } = useTranslation()

  if (global.currentUser.roles.includes('customer')) {
    return <Redirect to="/" />
  }

  const exampleData = {
    deliveryAddress: {
      name1: 'Max Mustermann',
      street: 'Musterstraße 1',
      zip: '12345',
      city: 'Musterstadt',
      country: 'DE',
    },
    slaType: 'ONN',
    colis: [{ weight: 1, length: 10, width: 10, height: 10 }],
  }

  return (
    <Container>
      <Row className="mt-4">
        <Col md="12">
          <Card
            title={i18n.t(
              'download_printingtool',
              'PrintingTool herunterladen',
            )}
            notoggle
          >
            <h3>
              {i18n.t('automatic_lable_print', 'Automatischer Labeldruck')}
            </h3>
            <i
              className="fas fa-print fa-2x"
              style={{ float: 'left', margin: 17 }}
            ></i>
            <p>
              {i18n.t(
                'download_printingtool_text',
                'Wenn das PrintingTool auf einem PC/Laptop läuft und Aufträge in der Webauftragserfassung erstellt werden, dann wird durch das PrintingTool das Etikett auf einem definierten Drucker automatisch ausgedruckt. Das PrintingTool stellt dauerhaft eine Verbindung via Internet zum Webauftragsserver her und prüft, ob neue Daten zum Drucken vorhanden sind. Wenn Daten vorhanden sind, werden diese heruntergeladen und je nach Einstellungen verarbeitet. Somit müssen die Labels nicht mehr manuell gedruckt werden. Wichtig: Stellen Sie sicher, dass das .Net Framework und die C++ Redistributable Packages auf dem PC installiert sind. In der Regel sind diese bereits vorinstalliert.',
              )}
            </p>
            <div className="clearfix"></div>
            <a
              href="/api/printing-tool-download"
              target="_blank"
              className="btn btn-primary"
            >
              <i className="fas fa-arrow-square-down"></i>
              {i18n.t('download_printingtool', 'PrintingTool herunterladen')}
            </a>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Card title={i18n.t('api_doc', 'API Dokumentation')} notoggle>
            <h3>
              {i18n.t(
                'automatic_order_transfer',
                'Aufträge automatisch übertragen',
              )}
            </h3>
            <i
              className="fas fa-upload fa-2x"
              style={{ float: 'left', margin: 17, marginTop: 5 }}
            ></i>
            {i18n.t(
              'api_doc_text',
              'Per API lassen sich aus existierenden Systemen die Aufträge automatisch an die Auftragserfassung weiterreichen. Die Auftragserfassung meldet automatisch die Auftragsdetails und auf Wunsch ein Label zurück.',
            )}
            <div className="clearfix"></div>
            <a
              href="/docs"
              to="/docs"
              target="_blank"
              className="btn btn-primary"
            >
              <i className="fas fa-link"></i>
              {i18n.t('api_doc_open', 'API Dokumentation öffnen')}
            </a>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Card
            title={i18n.t('url_param_order', 'Werte vorausfüllen über die URL')}
            notoggle
          >
            <h3>
              {i18n.t('prefill_orderform', 'Auftragsformular vorausfüllen')}
            </h3>

            <p>
              {i18n.t(
                'you_can_preassign_values_to_the_order_form_fields_by_setting_the_query_parameter',
                'Sie können die Auftragsformularfelder mit Werten vorbelegen, indem Sie den query parameter',
              )}{' '}
              <code>initial_values</code>{' '}
              {i18n.t(
                'with_the_url_encoded_format_below',
                'mit dem URL kodiertem Format unterhalb setzen.',
              )}
            </p>

            <p>
              {i18n.t('possible_fields_are', 'Mögliche Felder sind')}{' '}
              <code>pickupAddress</code>, <code>deliveryAddress</code>,{' '}
              <code>slaType</code> {i18n.t('and', 'und')} <code>colis</code>.
            </p>

            <h4>{i18n.t('example_json_format', 'Beispiel JSON Format')}</h4>

            <pre>{JSON.stringify(exampleData, null, 2)}</pre>
            <h4>
              {i18n.t(
                'example_url_coded_format',
                'Beispiel URL-encoded Format',
              )}
            </h4>
            <code>
              {[
                window.location.protocol,
                '//',
                window.location.host,
                `?initial_values=${encodeURIComponent(
                  JSON.stringify(exampleData),
                )}`,
              ]
                .filter(Boolean)
                .join('')}
            </code>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Interfaces
